import axios from 'axios';
import MainURL from '../../../../MainURL';
import ImageURL from '../../../../ImageURL';

// 번들 이미지(/static/...)·data URI 는 그대로, 서버 업로드 파일명이면 서버 경로로
function isResolvedSrc(src: string) {
  return /^(data:|https?:|\/)/.test(src);
}

// 증명사진
export function profileImageSrc(profileImage: string) {
  return isResolvedSrc(profileImage) ? profileImage : `${ImageURL}/images/resume/profile/${profileImage}`;
}

// 포트폴리오 썸네일/사진 — 서버 uploads/images/resume/portfolio
export function portfolioImageSrc(image: string) {
  return isResolvedSrc(image) ? image : `${ImageURL}/images/resume/portfolio/${image}`;
}

// 관리자 통계(countall) — ministerinfoview: 목록 진입, ministerinfodetail: 상세 열기 시도
export function countUpMinisterStat(type: 'ministerinfoview' | 'ministerinfodetail') {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');
  axios.post(`${MainURL}/admin/countup`, { date: `${yyyy}-${mm}-${dd}`, type }).catch(() => null);
}
